import css from './PriceRange.module.scss'
import React from 'react'
import { Range } from 'react-input-range'
import MediaQuery from 'react-responsive'

import { BreakpointsMaxWidth } from 'meta/layout/breakpoints'

import Desktop from 'components/Checkout/TicketSelection/Filters/PriceRange/Desktop'
import Mobile from 'components/Checkout/TicketSelection/Filters/PriceRange/Mobile'
import { useDynamicCss } from 'hooks/useDynamicCss'

interface IProps {
  setPriceRangeCallback(range: Range): void
  priceRangeInitial: Range
  priceRangeCurrent: Range
}

const PriceRange: React.FC<IProps> = (props) => {
  const { priceRangeInitial, priceRangeCurrent, setPriceRangeCallback } = props

  const isStyleLoaded = useDynamicCss('/styles/react-input-range.css')
  if (!isStyleLoaded) return

  return (
    <div className={css.checkout_ticketselection_filters_pricerange_container}>
      <MediaQuery maxWidth={BreakpointsMaxWidth.mobile}>
        <Mobile
          priceRangeCurrent={priceRangeCurrent}
          priceRangeInitial={priceRangeInitial}
          setPriceRangeCallback={setPriceRangeCallback}
        />
      </MediaQuery>

      <MediaQuery minWidth={BreakpointsMaxWidth.mobile}>
        <Desktop
          priceRangeInitial={priceRangeInitial}
          priceRangeCurrent={priceRangeCurrent}
          setPriceRangeCallback={setPriceRangeCallback}
        />
      </MediaQuery>
    </div>
  )
}

export default PriceRange
